
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","viewBox":"0 0 33 33","fill":"#FFF","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.1 2.817C8.783 2.817 2.817 8.783 2.817 16.1c0 7.33 5.878 13.283 13.183 13.283 7.317 0 13.283-5.966 13.283-13.283 0-7.33-5.878-13.283-13.183-13.283zM-.017 16.1C-.017 7.217 7.217-.017 16.1-.017c8.895 0 16.017 7.247 16.017 16.117 0 8.883-7.234 16.117-16.117 16.117C7.105 32.217-.017 24.97-.017 16.1z"}}),_c('path',{attrs:{"d":"M14.7 22.8h2.8v-9.7h-2.8v9.7zm0-11h2.8V9.4h-2.8v2.4z"}})])
          )
        }
      }
    